// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
.container {
  justify-content: space-between;
  background: white;
  border-radius: 8px;
  padding: 30px;
  margin: 13px 4px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: 20px;
    margin-top: 77px;

  }
}
.heading {
  color: var(--help-center-black, #000);
  font-family: Nunito;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 18px;
  }
}
.left-section {
  align-items: flex-start;
}
.right-section {
  align-items: flex-end;
}
.scrollable-section {
  max-height: 350px;
  overflow-y: auto;
}
.content {
  display: flex;
  width: 493px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  color: var(--new-tcp-black, #000);
  font-family: Nunito;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  overflow: hidden;
  @media ${(props) => props.theme.mediaQuery.smallMax}{
    width: 220px;
    padding: 12px 16px;
  }
}
.notation {
  font-size: 10px;
}
.message {
  font-size: 18px;
}
.summary {
  display: flex;
  flex-direction: column;
  margin: 24px 2px;
}
input,
button {
  margin-top: 1rem;
}
.form-container {
  display: flex;
}
.form-container input[type="text"] {
  flex: 1;
  outline: none;
  border-radius: 30px;
  border: 1px solid #254F6E;
  background: var(--new-tcp-white, #FFF);
  height: 12px;
  padding: 13px 20px 13px 24px;
  color: var(--grey-gray-darkest, #1A1A1A);
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: 10px 18px;
    height: 18px;
  }
}
.form-container button {
  border: none;
  outline: none;
  cursor: pointer;
  height: 40px;
  padding: 10px 30px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  background: var(--help-center-dark-blue, #1E56AA);
  margin-left: 24px;
  color: #FFF;
  text-align: center;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: 10px 20px;
    margin-left: 8px;
  }
}
.loader {
  height: 26px;
  padding: 12px 16px;
  float: right;
  margin: 0px 2px 24px 2px;
  letter-spacing: 2.4px;
  width: 18px;
  align-items: flex-start;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  justify-content: space-between;
  font-family: Nunito;
  font-size: 22px;
  line-height: 22px;
  font-style: normal;
  font-weight: 800;
}
.disable-dot {
  color: var(--grey-gray-light, #D8D8D8);
  font-weight: normal;
}
.active-dot {
  color: var(--new-tcp-black, #000);
  font-weight: bold;
}
`;



